import { StyleSheet } from 'aphrodite';
import { destructive } from '../../../../../web/styles/colors';
import { CssSelectors, absoluteCenterStyle } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	autoDiscoverButton: {
		marginTop: 16,
	},
	manageDomainButton: {
		marginTop: 12,
	},
	checkbox: {
		...CssSelectors.allDescendants({
			height: 30,
			marginRight: 5,
			verticalAlign: 'middle',
		}),
		display: 'inline',
	},
	container: {
		borderBottom: '1px solid #cccccc77',
		paddingBottom: 20,
		paddingTop: 10,
	},
	dropDown: {
		fontSize: 12,
		height: 30,
		flex: 1,
		minWidth: 100,
	},
	exchangeUrl: {
		flex: 1,
	},
	fields: {
		display: 'flex',
		width: '100%',
		...CssSelectors.allChildren({
			marginRight: 10,
			verticalAlign: 'middle',
		}),
	},
	header: {
		color: '#a7abad',
		fontSize: 12,
	},
	hostName: {
		flex: 1,
		minWidth: 150,
	},
	label: {
		color: '#a7abad',
		fontSize: 10,
		marginTop: 0,
	},
	loading: {
		...absoluteCenterStyle,
	},
	portNumber: {
		width: 75,
	},
	section: {
		marginTop: 10,
	},
	sendLimit: {
		width: 70,
	},
	sendOptions: {
		display: 'flex',
		flexDirection: 'row',
	},
	smtpOnly: {
		marginTop: 8,
	},
	smtpOnlyWarning: {
		color: destructive,
		fontSize: 12,
	},
	textBox: {
		background: '#f9f9f9',
		border: '1px solid #ccc',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: '#0d0f11',
		fontSize: 14,
		height: 30,
		padding: '5px 5px 5px 10px',
		flex: 1,
		minWidth: 150,
	},
	unsupportedISP: {
		margin: '12px 5px 12px 0',
	},
	useLevCheckbox: {
		...CssSelectors.allChildren(
			{
				width: 300,
			},
			'div'
		),
	},
	useLevSelect: {
		flex: 1,
		minWidth: 200,
	},
	useLevText: {
		paddingLeft: 10,
		width: 300,
	},
});
